<template>
  <v-app>
    <v-navigation-drawer
      width="300"
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      persistent
      enable-resize-watcher
      fixed
      app
    >
      <v-toolbar color="primary darken-1" dark text-center>
        <v-layout align-center justify-center row fill-height>
          <router-link :to="{ name: firstPage }" class="routerName mt-2">
            <img src="@/assets/logoBW.svg" alt="ooca logo" style="width: 100px" />
          </router-link>
        </v-layout>
      </v-toolbar>
      <v-list expand dense>
        <template v-for="item in items" v-if="configRouter">
          <v-list-item
            v-if="!item.items"
            v-show="checkAuthorized(item.routerName || item.name, item.name)"
            :to="item.href ? undefined : { name: item.routerName }"
            :href="item.href"
            :target="item.href ? '_blank' : undefined"
            :key="item.title"
          >
            <v-list-item-icon>
              <v-icon v-if="item.action">{{ item.action }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            v-show="checkAuthorizedByGroup(item.name) || item.items.some((subItem) => checkLegacy(subItem))"
            :prepend-icon="item.action"
            :key="item.title"
            no-action
            :group="item.active ? '' : item.group"
            :value="item.active"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="subItem in item.items">
              <v-list-item
                v-show="checkAuthorized(item.name, subItem.routerName || subItem.name) || checkLegacy(subItem)"
                :key="subItem.title"
                :to="subItem.href ? undefined : { name: subItem.routerName }"
                :href="subItem.href"
                :target="subItem.href ? '_blank' : undefined"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app :clipped-left="clipped" color="primary" :extension-height="extendedToolbar ? 30 : 0">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" dark />
      <router-link v-if="firstPage" :to="{ name: firstPage }" class="routerName">
        <v-btn icon dark>
          <v-icon>home</v-icon>
        </v-btn>
      </router-link>
      <span class="title white--text">{{ headerName }}</span>
      <template v-slot:extension v-if="extendedToolbar">
        <v-tabs dark color="white" background-color="transparent" height="30px" show-arrows align-with-title>
          <v-tabs-slider color="warning"></v-tabs-slider>
          <template v-if="routerName === 'providerTypeDetail'">
            <v-tab @click="$vuetify.goTo(0)"> Information </v-tab>
            <!-- <v-tab @click="$vuetify.goTo('#subtype', optionTab)">
              Subtype
            </v-tab> -->
          </template>
          <template v-if="routerName === 'providerProfile'">
            <v-tab @click="$vuetify.goTo(0)"> General </v-tab>
            <v-tab @click="$vuetify.goTo('#visibility', optionTab)"> visibility </v-tab>
            <v-tab @click="$vuetify.goTo('#profession', optionTab)"> Profession Information </v-tab>
            <v-tab @click="$vuetify.goTo('#education', optionTab)"> Education Information </v-tab>
            <v-tab @click="$vuetify.goTo('#bank', optionTab)"> Bank Information </v-tab>
            <v-tab @click="$vuetify.goTo('#topicTags', optionTab)"> Topic Tags </v-tab>
            <!-- <v-tab @click="$vuetify.goTo('#providerSubtype', optionTab)">
              Provider Subtype
            </v-tab> -->
            <v-tab @click="$vuetify.goTo('#providerTier', optionTab)"> Provider Tier </v-tab>
          </template>
        </v-tabs>
      </template>
      <v-spacer />
      <v-btn icon dark @click="handleFullScreen()">
        <v-icon>{{ fullScreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
      </v-btn>
      <v-btn icon dark @click="changeMode()">
        <v-icon :color="currentMode ? 'warning' : ''">{{ 'brightness_2' }}</v-icon>
      </v-btn>
      <v-menu offset-y origin="bottom center" :nudge-bottom="10" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon dark ripple="ripple" text slot="activator">
            <v-avatar size="30px">
              <v-icon>person</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-action>
              <v-icon>person</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ user.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-action>
              <v-icon>input</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <slot />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../store';
import loader from '../utils/loader';
import authService from '../services/auth';
import windowUtil from '../utils/window';
import arrayUtil from '../utils/arrayUtil';
import { canOpenPage } from '../utils/permission';

export default {
  store,
  data() {
    return {
      firstPage: null,
      clipped: false,
      drawer: true,
      fixed: false,
      dark: false,
      fullScreen: false,
      items: [
        {
          action: 'person_search',
          title: 'Provider',
          active: true,
          name: 'provider',
          group: '/provider',
          items: [
            {
              title: 'Provider List',
              routerName: 'provider',
            },
            {
              title: 'Provider Archived List',
              routerName: 'providerArchived',
            },
            {
              title: 'Provider Type List',
              routerName: 'providerType',
            },
            {
              title: 'Provider Performance',
              routerName: 'providerPerformance',
            },
            {
              title: 'Provider Transaction',
              routerName: 'providerTransaction',
            },
          ],
        },
        {
          action: 'add_circle',
          title: 'New Appointment',
          routerName: 'newAppointment',
        },
        {
          action: 'person_pin',
          title: 'Patient',
          routerName: 'patient',
        },
        {
          action: 'account_balance_wallet',
          title: 'Wallet Order',
          routerName: 'wallet-order',
        },
        {
          action: 'sms',
          title: 'Notification',
          name: 'notifications',
          items: [
            { title: 'Notification', routerName: 'notification', legacyPermission: 'notification' },
            { title: 'ปฏิทินวันพิเศษ', routerName: 'specialDays' },
          ],
        },
        {
          action: 'medication',
          title: 'Prescription',
          name: 'prescription',
          items: [
            { title: 'Prescription List', routerName: 'prescriptionList' },
            { title: 'Medicines', routerName: 'medicines' },
            { title: 'B2B Discount', routerName: 'B2BDiscount' },
          ],
        },
        {
          action: 'calendar_today',
          title: 'Calendar',
          name: 'calendar',
          items: [
            { title: "Provider's Schedule", routerName: 'providerSchedule' },
            // {title: 'Appointment', routerName: 'appointmentSchedule'},
          ],
        },
        {
          action: 'date_range',
          title: 'Report',
          name: 'report',
          group: '/report',
          items: [{ title: 'All Appointment', routerName: 'allAppointment' }],
        },
        {
          action: 'credit_card',
          title: 'Home Feed',
          routerName: 'homefeed',
        },
        {
          action: 'credit_card',
          title: 'Coupon',
          routerName: 'coupon',
        },
        {
          action: 'card_giftcard',
          title: 'Voucher',
          name: 'voucher',
          group: '/voucher',
          active: true,
          items: [
            {
              title: 'Voucher Order',
              routerName: 'voucherOrder',
            },
            {
              title: 'Voucher List',
              routerName: 'voucher',
            },
          ],
        },
        {
          action: 'business',
          title: 'Corporate',
          name: 'corporate',
          routerName: 'corporate',
        },
        {
          action: 'sms',
          title: 'Send SMS',
          routerName: 'sendSms',
        },
        {
          action: 'assessment',
          title: 'Assessment(Legacy Soon)',
          routerName: 'assessment',
        },
        {
          action: 'assessment',
          title: 'Assessment',
          name: 'assessments',
          group: '/assessments',
          active: true,
          items: [
            {
              title: 'B2C Assessment',
              routerName: 'b2cAssessments',
            },
            {
              title: 'B2B Assessment',
              routerName: 'b2bAssessments',
            },
          ],
        },
        {
          action: 'sms',
          title: 'Chat',
          name: 'chat',
          group: '/chat',
          active: true,
          items: [
            {
              title: 'Chat Room',
              routerName: 'chatroom',
            },
            {
              title: 'Chat System Prompt',
              routerName: 'chatSystemPrompt',
            },
            {
              title: 'Phoenix (AI Traces)',
              name: 'phoenix',
              href: process.env.VUE_APP_PHOENIX_URL,
            },
          ],
        },
        {
          action: 'block',
          title: 'User Blocked Provider',
          routerName: 'userBlockedProvider',
        },
        {
          action: 'security',
          title: 'Permission Setting',
          routerName: 'permission',
        },
        {
          action: 'person',
          title: 'User Management',
          routerName: 'userManagement',
        },
        {
          action: 'mdi-email-multiple-outline',
          title: 'Email Blast',
          name: 'emailBlast',
          group: '/email-blast',
          active: true,
          items: [
            { title: 'Templates', routerName: 'EmailBlastTemplates' },
            { title: 'Send Blast', routerName: 'EmailBlastSend' },
          ],
        },
      ],
      miniVariant: false,
    };
  },
  computed: {
    configRouter() {
      return store.state.setting.authorization;
    },
    user() {
      return store.state.auth.user || '';
    },
    currentMode() {
      return this.$vuetify.theme.dark;
    },
    optionTab() {
      return {
        // duration: this.duration,
        offset: -80,
        // easing: this.easing
      };
    },
    routerName() {
      return this.$route.name;
    },
    headerName() {
      return this.$route.meta.headerName;
    },
    extendedToolbar() {
      return !!this.$route.meta.extendedToolbar;
    },
    ...mapGetters({ isDark: 'layout/currentMode' }),
  },
  created() {},
  mounted() {
    this.$vuetify.theme.dark = this.isDark;
  },
  watch: {
    configRouter(val) {
      if (val) {
        const hasValidRole = arrayUtil.intersect(Object.keys(val.startPage), this.user.roles);
        this.firstPage = val.startPage[hasValidRole[0]];
      }
    },
    isDark(val) {
      this.$vuetify.theme.dark = val || false;
    },
  },
  methods: {
    logout() {
      authService.logout('login').then(() => {
        this.$notify({
          title: 'Logout Success',
          text: 'Goodbye',
          type: 'info',
        });
      });
    },
    changeMode() {
      store.dispatch('layout/setMode');
    },
    handleFullScreen() {
      windowUtil.toggleFullScreen().then((data) => {
        this.fullScreen = data;
      });
    },
    checkAuthorized(name, subName) {
      let authType = null;
      if (subName && this.configRouter[name] && this.configRouter[name][subName]) {
        authType = this.configRouter[name][subName].authType;
      } else {
        authType = this.configRouter[name] ? this.configRouter[name].authType : null;
      }
      if (subName) return arrayUtil.intersect(authType, store.state.auth.roles).length;
      else return arrayUtil.intersect(authType, store.state.auth.roles).length;
    },
    checkLegacy(subItem) {
      return (
        !!subItem.legacyPermission &&
        canOpenPage(this.configRouter, store.state.auth.roles || [], { key: subItem.legacyPermission })
      );
    },
    checkAuthorizedByGroup(name) {
      const group = this.configRouter[name];
      let showMenuGroup = false;
      for (let key in group) {
        showMenuGroup = showMenuGroup | arrayUtil.intersect(group[key].authType, store.state.auth.roles).length;
      }
      return showMenuGroup;
    },
  },
  components: {
    Footer: loader.component('Footer'),
  },
};
</script>

<style lang="scss"></style>
